import { styled } from 'goober'

export const Content = styled('main')`
  flex: 1;
  display: flex;
`

export const EditorContent = styled('main')`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const LoadingContainer = styled('main')`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  justify-content: center;
  text-align: center;
`
